/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'view': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M97.301 48.898C89.399 29.5 70.899 17 50 17S10.602 29.5 2.699 48.898c-.3.7-.3 1.5 0 2.2 5.102 12.601 14.801 22.5 27.398 27.8C36.499 81.7 43.199 83 49.999 83c6.5 0 12.898-1.2 19.102-3.7 12.699-5.199 23-15.397 28.199-28.198.3-.704.3-1.5 0-2.203zM66.899 73.699c-11.102 4.5-23.398 4.398-34.398-.3C21.7 68.898 13.399 60.6 8.802 50 15.9 33.5 32.001 23 50.001 23S84.103 33.602 91.2 50c-4.598 10.7-13.5 19.301-24.301 23.7z"/><path pid="1" d="M50 32.398c-9.7 0-17.602 7.898-17.602 17.602 0 9.7 7.902 17.602 17.602 17.602S67.602 59.704 67.602 50c0-9.7-7.902-17.602-17.602-17.602zm0 29.203c-6.398 0-11.602-5.2-11.602-11.602 0-6.398 5.203-11.602 11.602-11.602s11.602 5.2 11.602 11.602c0 6.398-5.203 11.602-11.602 11.602z"/>'
  }
})
